import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import {useDistributorsQueryQuery} from "../../generated/graphql";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const DistributorSelect = (props) => {
    const query = useDistributorsQueryQuery();
    return props.valueIsId?
        <GraphQlSelectId queryResult={query} {...props}  labelField="name" />:
        <GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}